module.exports = __webpack_public_path__ + "static/media/LouverMontage.d52bfb85.png";